// extracted by mini-css-extract-plugin
export var caption = "bC_gz";
export var grey = "bC_dK";
export var heading = "bC_G";
export var image = "bC_k";
export var left = "bC_bK";
export var reverse = "bC_dG";
export var right = "bC_bY";
export var section = "bC_j";
export var video = "bC_gB";
export var videoContainer = "bC_cg";
export var videoWrapper = "bC_ch";